query ListMyTickerBars {
  tickerBars: StreamToolsListMyTickerBars {
    tickerBarId
    name
    createdAt
    updatedAt
  }
}
